import { StyledButton } from './styles';

type ButtonProps = {
  width?: number | string | undefined,
  height?: number | string | undefined,
  theme: string,
  text: string,
  iconLeft?: any,
  iconRight?: any
  onClick?: () => void
}

export default function Button({ width, height, theme, text, iconLeft, iconRight, onClick }: ButtonProps) {
  return (
    <StyledButton $theme={theme} $width={width} $height={height} onClick={onClick}>
      {iconLeft ? iconLeft : null}
      {text}
      {iconRight ? iconRight : null}
    </StyledButton>
  )
}